module.exports = __webpack_public_path__ + "bg-boost-desktop.svg?dc8b886b4cf2a2426a6664ad17ebf7f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-boost-desktop.svg
// module id = 19
// module chunks = 0